import { Controller, useFormContext } from 'react-hook-form';

import { TextInput } from 'components/DesignSystem/TextInput';
import { FormProps } from 'components/widgets/CustomerProfile/CustomerProfile';

export const MaxWbsLevel = () => {
    const methods = useFormContext<FormProps>();
    return (
        <Controller
            render={({ field }) => <TextInput {...field} label={'Maximum WBS level'} />}
            name={`maxWbsLevel`}
            control={methods.control}
        />
    );
};
